// Markets where online booking is blocked (backend disableOnlineBooking) keep the full NPV block.
// A market status that failed to load is treated as closed so in-clinic slots never leak.
export const shouldHideInClinicNpvSlots = ({
  flagOn,
  patientFacing,
  marketStatusFailed = false,
  onlineBookingUnavailable,
  newPatientVisit
}: {
  flagOn: boolean;
  patientFacing?: boolean;
  marketStatusFailed?: boolean;
  onlineBookingUnavailable: boolean;
  newPatientVisit: boolean;
}) =>
  flagOn &&
  newPatientVisit &&
  !onlineBookingUnavailable &&
  (patientFacing === false || marketStatusFailed);
